import { api } from "./client";

export const orgFeaturesService = {
  async get(orgId: string): Promise<Record<string, boolean>> {
    const response = await api.get<{ features: Record<string, boolean> }>(
      `/organizations/${orgId}/features`,
    );
    return response.data.features ?? {};
  },

  async put(orgId: string, features: Record<string, boolean>): Promise<Record<string, boolean>> {
    const response = await api.put<{ features: Record<string, boolean> }>(
      `/organizations/${orgId}/features`,
      { features },
    );
    return response.data.features ?? {};
  },
};
